import { gql } from '@apollo/client'
import {
    FileInfoFragment,
    ParagraphRevisionFragment,
} from '../fragments/importFile.fragments'
import { tableInfoFragment } from '../fragments/table.fragment'

export const CheckForDuplicateAssociationQuery = gql`
    query hasProjectProductFamily($input: GetProjectProductFamilyInput!) {
        hasProjectProductFamily(input: $input) {
            treePath
            familyExist
            familyName
        }
    }
`
export const GetImportFilesQuery = gql`
    query projectImportedProductFamilyDetails($projectId: String!) {
        projectImportedProductFamilyDetails(projectId: $projectId) {
            familyId
            fileKey
            title
            firmId
            dateTimeImported
            diffFileExpired
            parentAssemblyTreePaths
            productTypeCount
            familyGuid
            productTypeInfo {
                name
                propertiesCount
                textType
            }
            propertiesCount
            errors
            warnings
            paragraphErrors {
                ...paragraphRevisionFragment
            }
            paragraphWarnings {
                ...paragraphRevisionFragment
            }
            backConvertedDiffDocxUri
            productFamilyAndTypeAssociation {
                productFamilyAssociations {
                    parentElementId
                    productFamilyTreePath
                }
                productTypeAssociations {
                    associatedTreePath
                    productTypeName
                }
            }
        }
    }
    ${ParagraphRevisionFragment}
`

export const CheckForDuplicateFileQuery = gql`
    query getImportDuplicateFamily($input: ImportProjectProductFamilyInput!) {
        getImportDuplicateFamily(input: $input) {
            firmId
            projectId
            duplicateFamilies {
                fileKey
                familyId
            }
            userImportedFamilies {
                fileKey
                familyId
            }
            errorMessage
            instanceId
        }
    }
`

export const ImportFileExtractionQuery = gql`
    query getimportFamilyInfoFromFile(
        $input: ImportProjectProductFamilyInput!
    ) {
        getimportFamilyInfoFromFile(input: $input) {
            ...fileInfoFragment
        }
    }
    ${FileInfoFragment}
`
export const getChildQuery = (depth: number): string => {
    if (depth === 0) return ''
    return `
    children {
                        index
                        type
                        isHidden
                        tableIdentifier
        ${getChildQuery(depth - 1)}
         content {
                        id
                        type
                        text
                        imperialUnits
                        metricUnits
                        hyperlinkUrl
                        optionItemState
                        elements {
                            id
                            type
                            text
                            imperialUnits
                            metricUnits
                            hyperlinkUrl
                            optionItemState
                            elements {
                                id
                                type
                                text
                                imperialUnits
                                metricUnits
                                hyperlinkUrl
                                optionItemState
                                elements {
                                    id
                                    type
                                    text
                                    imperialUnits
                                    metricUnits
                                    hyperlinkUrl
                                    optionItemState
                                }
                            }
                        }
                    }
                    hierarchicalLevel
               
    }
    `
}

export const GetProductFamilyPreviewQuery = () => {
    const elements = getChildQuery(6)
    return gql`
    query getImportFamilyPreview(
        $input: ProjectProductFamilyFileInput!
    ) {
        getImportFamilyPreview(input: $input) {
            fileName
            fileKey
            instanceId
            errorMessage
            status
            sectionPreview{
                sectionNumber
                sectionName
                prefix
                title
                documentDetails {
                    lastModified
                    author
                }
                paragraphs {
                    index
                    type
                    tableIdentifier
                    ${elements}
                    isHidden
                    content {
                        id
                        type
                        text
                        imperialUnits
                        metricUnits
                        hyperlinkUrl
                        optionItemState
                        elements {
                            id
                            type
                            text
                            imperialUnits
                            metricUnits
                            hyperlinkUrl
                            optionItemState
                            elements {
                                id
                                type
                                text
                                imperialUnits
                                metricUnits
                                hyperlinkUrl
                                optionItemState
                                elements {
                                    id
                                    type
                                    text
                                    imperialUnits
                                    metricUnits
                                    hyperlinkUrl
                                    optionItemState
                                }
                            }
                        }
                    }
                    hierarchicalLevel
                    
                }
                tables {
                    ...tableInfoFragment
                  }
            }
        }
    }
    ${tableInfoFragment}
`
}
export const GetProductTypePreviewQuery = () => {
    const elements = getChildQuery(6)
    return gql`
    query getImportedProductTypePreview(
        $input: UserImportedFamilyProductTypeInput!
    ) {
        getImportedProductTypePreview(input: $input) {
            fileName
            fileKey
            instanceId
            errorMessage
            status
            sectionPreview{
                sectionNumber
                sectionName
                prefix
                title
                documentDetails {
                    lastModified
                    author
                }
                paragraphs {
                    index
                    type
                    ${elements}
                    content {
                        id
                        type
                        text
                        imperialUnits
                        metricUnits
                        hyperlinkUrl
                        optionItemState
                        elements {
                            id
                            type
                            text
                            imperialUnits
                            metricUnits
                            hyperlinkUrl
                            optionItemState
                            elements {
                                id
                                type
                                text
                                imperialUnits
                                metricUnits
                                hyperlinkUrl
                                optionItemState
                                elements {
                                    id
                                    type
                                    text
                                    imperialUnits
                                    metricUnits
                                    hyperlinkUrl
                                    optionItemState
                                }
                            }
                        }
                    }
                    hierarchicalLevel
                    
                }
            }
        }
    }
`
}
export const DuplicateImportedFamilies = gql`
    query getDuplicateImportedFamilies(
        $input: GetDuplicateImportedFamiliesInput!
    ) {
        getDuplicateImportedFamilies(input: $input) {
            warnings
            addImportedItemsToWorkspace
            backConversionDiscrepancyMessage
            backConvertedDiffDocxUri
            diffFileExpired
            dateTimeImported
            errors
            familyId
            firmId
            notesToSpecifierCount
            productTypeCount
            productTypeInfo {
                name
                notesToSpecifierCount
                propertiesCount
            }
            projectId
            propertiesCount
            title
            fileKey
            status
            familyGuid
            isDeleted
            productFamilyAndTypeAssociation {
                productFamilyAssociations {
                    productFamilyTreePath
                    parentElementId
                }
                productTypeAssociations {
                    productTypeName
                    associatedTreePath
                }
            }
        }
    }
`

export const GetMasterSpecTemplateQuery = gql`
    query getMasterSpecTemplate {
        getMasterSpecTemplate {
            masterSpecTemplateDocument
        }
    }
`

export const GetDuplicateOfficeMasterImportedFamilies = gql`
    query getDuplicateOfficeMasterImportedFamilies(
        $input: GetDuplicateImportedFamiliesInput!
    ) {
        getDuplicateOfficeMasterImportedFamilies(input: $input) {
            projectElementNodes {
                id
                elementId
                elementType
                baseElementId
                nodeOrder
                isInProject
                isDeactivated
                text
                treePath
                parentTreePath
                parentNodeId
                projectId
                isSearchResult
                hasChildren
                isPrimaryIteration
                iteration {
                    id
                    name
                }
            }
            totalCount
        }
    }
`

export const MatchAssemblyAssociationsWithExistingVersionsQuery = gql`
    query matchAssemblyAssociationsWithExistingVersions(
        $input: CheckAssemblyAssociationsInput
    ) {
        matchAssemblyAssociationsWithExistingVersions(input: $input) {
            results {
                familyName
                familyNumber
                notMatchingAssemblyTreePaths
            }
        }
    }
`
